<style scoped>
    .demo-drawer-footer{
        width: 750px;
        position: fixed;
        bottom: 0;
        right: 0;
        border-top: 1px solid #e8e8e8;
        padding: 10px 16px;
        text-align: right;
        background: #fff;
    }
</style>
<template>
    <Spin v-if="preloading" size="large" fix>
        <Icon type="ios-loading" size=18 class="demo-spin-icon-load"></Icon>
        <div style="font-size: 12px">正在获取设备信息...</div>
    </Spin>
    <div v-else>
        <Steps style="margin-left:10px; margin-top: 20px" :current="current">
            <Step @click.native="current = 0" title="触发条件选择"></Step>
            <Step @click.native="current = 1" title="关联分类选择"></Step>
            <Step @click.native="current = 2" title="关联设备选择"></Step>
            <Step @click.native="current = 3" title="设备状态"></Step>
            <Step @click.native="current = 4" title="设置场景"></Step>
        </Steps>
        <!--触发条件选择-->
        <div v-show="current == 0">
            <RadioGroup v-model="sceneType"  style="margin-top: 15px;margin-left: 15px">
                <Radio label="1">
                    <Icon type="md-alarm" />
                    <span>自动</span>
                </Radio>
                <Radio label="2">
                    <Icon type="ios-hand" />
                    <span>手动</span>
                </Radio>
            </RadioGroup>
            <CheckboxGroup v-if="sceneType==1" v-model="box" style="margin-top: 10px;margin-bottom: 10px">
                <Checkbox label="ds">
                    <Icon type="md-alarm" />
                    <span>定时触发</span>
                </Checkbox>
                <Checkbox label="cgq">
                    <Icon type="ios-beaker" />
                    <span>传感器触发</span>
                </Checkbox>
            </CheckboxGroup>
            <div v-if="sceneType==1">
                <Form>
                    <FormItem label="循环开关" >
                        <i-switch v-model="isLoop" />
                    </FormItem>
                </Form>
                <!--定时表单-->
                <Form v-if="box.indexOf('ds')!=-1" ref="dsForm" :model="dsForm" :rules="dsValidate" >
                    <FormItem  label="开启时间" prop="ktime">
                        <Row style="display: flex;">
                            <Col span="11">
                            <DatePicker v-model="dsForm.kdate" :start-date="new Date()" show-week-numbers type="date" placeholder="请选择日期" style="width: 200px"></DatePicker>
                            </Col>
                            <Col span="2">-</Col>
                            <Col span="11">
                            <TimePicker placement="top-start" v-model="dsForm.ktime" format="HH:mm" placeholder="请选择时间" style="width:200px"></TimePicker>
                            </Col>
                        </Row>
                    </FormItem>
                    <FormItem label="结束时间" prop="jtime">
                        <Row style="display: flex;">
                            <Col span="11">
                            <DatePicker v-model="dsForm.jdate" :start-date="new Date()" show-week-numbers type="date" placeholder="请选择日期" style="width: 200px"></DatePicker>
                            </Col>
                            <Col span="2">-</Col>
                            <Col span="11">
                            <TimePicker placement="top-start" v-model="dsForm.jtime" format="HH:mm" placeholder="请选择时间" style="width: 200px"></TimePicker>
                            </Col>
                        </Row>
                    </FormItem>
                    <FormItem label="定时重复开关"  prop="timingRepeat">
                        <i-switch @click.native="!dsForm.timingRepeat ? dsForm.repeatTime = [] : ''" v-model="dsForm.timingRepeat" />
                    </FormItem>
                    <FormItem label="重复类型选择" v-if="dsForm.timingRepeat" prop="startSymbol">
                        <Select v-model="dsForm.repeatTypeText"  label-in-value @on-change="repeatTypeSelect" prop="repeatList">
                            <Option v-for="item in repeatList" :value="item" :key="item">{{ item }}</Option>
                        </Select>
                    </FormItem>
                    <FormItem v-if="dsForm.timingRepeat&&dsForm.repeatType==2" label="每周" prop="repeatTime">
                        <ButtonGroup size="small">
                            <Button @click="weekSelect(1)" :class="[dsForm.repeatTime.indexOf(1) >= 0 ? 'ivu-btn-primary' : '']">星期一</Button>
                            <Button @click="weekSelect(2)" :class="[dsForm.repeatTime.indexOf(2) >= 0 ? 'ivu-btn-primary' : '']">星期二</Button>
                            <Button @click="weekSelect(3)" :class="[dsForm.repeatTime.indexOf(3) >= 0 ? 'ivu-btn-primary' : '']">星期三</Button>
                            <Button @click="weekSelect(4)" :class="[dsForm.repeatTime.indexOf(4) >= 0 ? 'ivu-btn-primary' : '']">星期四</Button>
                            <Button @click="weekSelect(5)" :class="[dsForm.repeatTime.indexOf(5) >= 0 ? 'ivu-btn-primary' : '']">星期五</Button>
                            <Button @click="weekSelect(6)" :class="[dsForm.repeatTime.indexOf(6) >= 0 ? 'ivu-btn-primary' : '']">星期六</Button>
                            <Button @click="weekSelect(7)" :class="[dsForm.repeatTime.indexOf(7) >= 0 ? 'ivu-btn-primary' : '']">星期日</Button>
                        </ButtonGroup>
                        <CheckboxGroup v-model="dsForm.repeatTime" style="display: none"></CheckboxGroup>
                    </FormItem>
                    <FormItem v-if="dsForm.timingRepeat&&dsForm.repeatType==3" label="每月" prop="repeatTime">
                        <ButtonGroup size="small">
                            <Button v-for="(item) in data" @click="weekSelect(item)" :class="[dsForm.repeatTime.indexOf(parseInt(item)) >= 0 ? 'ivu-btn-primary' : '']">{{item}}</Button>
                        </ButtonGroup>
                        <CheckboxGroup v-model="dsForm.repeatTime" ></CheckboxGroup>
                    </FormItem>
                </Form>
                <!--传感器表单-->
                <Form v-if="box.indexOf('cgq')!=-1" ref="cgqForm" :model="cgqForm" :rules="cgqValidate" >
                    <FormItem id="tf-form-item" label="传感器分类选择" prop="cgqsbtype">
                        <ul v-if="cgqfllist.length > 0" class="select-type">
                            <li v-for="(vo,index) in cgqfllist" :key="index" @click="onCgqFenleiChange(vo,index)" :class="[cgqForm.cgqsbtype.indexOf(vo.cid) >= 0 ? 'active' : '']">
                                <div><img :src="imgSrc+vo.cimg" alt=""><p style="font-size: 12px;">{{vo.cname}}</p></div>
                            </li>
                        </ul>
                        <p style="text-align: center; padding: 20px 0; color:#cecece" v-else>暂无分类</p>
                        <CheckboxGroup v-model="cgqForm.cgqsbtype" style="display: none"></CheckboxGroup>
                    </FormItem>

                    <FormItem id="tf-form-item" label="传感器设备选择" prop="cgqsbselect">
                        <ul v-if="cgqsblist.length > 0" class="select-type">
                            <li v-for="(vo,index) in cgqsblist" :key="index" @click="onCgqShebeiChange(vo,index)" :class="[cgqForm.cgqsbselect.indexOf(vo.did) >= 0 ? 'active' : '']">
                                <div><img :src="imgSrc+vo.dimg" alt=""><p style="font-size: 12px;">{{vo.dname}}</p></div>
                            </li>
                        </ul>
                        <p style="text-align: center; padding: 20px 0; color:#cecece" v-else>暂无设备</p>
                        <CheckboxGroup v-model="cgqForm.cgqsbselect" style="display: none"></CheckboxGroup>
                    </FormItem>
                    <!--喷灌植物-->
                    <FormItem  id="tf-form-item" label="植物类型选择" >
                        <Select v-model="floraCat" clearable label-in-value @on-change="onSelect" @on-clear="catClear" prop="floraCatList">
                            <Option v-for="item in floraCatList" :value="item" :key="item">{{ item }}</Option>
                        </Select>
                    </FormItem>

                    <p v-if="cgqForm.cgqkglist.length <= 0" style="text-align: center; padding: 20px 0; color:#cecece">请先选择设备</p>
                    <div style="width:488px;margin-left: 20px;" v-if="cgqForm.cgqkglist.length > 0 && item.dinfo.eid.indexOf('sensor-hw') == -1" v-for="(item,index) in cgqForm.cgqkglist" :key="index">
                        <!--传感器（红外不输入值，默认0/1）-->
                        <div v-if="!floraCat">
                            <FormItem label="请选择">
                                <ButtonGroup size="small">
                                    <Button @click="cgqForm.typeCurrent = index2; cgqForm.valueStart = '';cgqForm.valueShutdown='';checkMould()" v-for="(vo,index2) in $func.sensorData(item.dinfo.eid,item.dinfo.factoryType)" :key="index2" :class="[cgqForm.typeCurrent == index2 ? 'ivu-btn-primary' : '']">{{vo.name}}</Button>
                                </ButtonGroup>
                            </FormItem>
                            <FormItem label="开启值大小关系选择" prop="startSymbol">
                                <Select v-model="cgqForm.startSymbol"  label-in-value  prop="symbolList">
                                    <Option v-for="item in symbolList" :value="item" :key="item">{{ item }}</Option>
                                </Select>
                            </FormItem>
                            <FormItem label="开启值" prop="valueStart">
                                <Input v-model="cgqForm.valueStart" clearable placeholder="请输入开启值">
                                <span slot="append">{{$func.sensorData(item.dinfo.eid,item.dinfo.factoryType)[cgqForm.typeCurrent].union}}</span>
                                </Input>
                            </FormItem>
                            <FormItem label="关闭值大小关系选择" prop="startSymbol">
                                <Select v-model="cgqForm.shutdownSymbol"  label-in-value  prop="symbolList">
                                    <Option v-for="item in symbolList" :value="item" :key="item">{{ item }}</Option>
                                </Select>
                            </FormItem>
                            <FormItem   label="关闭值" prop="valueShutdown">
                                <Input :maxlength="10" v-model="cgqForm.valueShutdown" clearable placeholder="请输入关闭值" >
                                <span slot="append">{{$func.sensorData(item.dinfo.eid,item.dinfo.factoryType)[cgqForm.typeCurrent].union}}</span>
                                </Input>
                            </FormItem>
                        </div>
                    </div>
                </Form>
            </div>
            <div v-if="sceneType==2">
                <Form>
                    <FormItem label="循环开关" >
                        <i-switch  v-model="isLoop" />
                    </FormItem>
                </Form>
            </div>
            <!--<p v-if="sceneType==2" style="text-align: center; padding: 20px 0; color:#cecece" >手动模式无需设置触发条件</p>-->
        </div>

        <!--表单-->
        <Form ref="formValidate" :model="formValidate" :rules="ruleValidate" :label-width="100">
    <!--分类选择-->
    <div v-show="current == 1" style="margin-top: 30px;">
        <FormItem id="tf-form-item" label="分类选择" prop="sbtype">
            <ul v-if="clist.length > 0" class="select-type">
                <li v-for="(vo,index) in clist" :key="index" @click="onFenleiChange(vo,index)" :class="[formValidate.sbtype.indexOf(vo.cid) >= 0 ? 'active' : '']">
                    <div><img :src="imgSrc+vo.cimg" alt=""><p style="font-size: 12px;">{{vo.cname}}</p></div>
                </li>
            </ul>
            <p style="text-align: center; padding: 20px 0; color:#cecece" v-else>暂无分类</p>
            <CheckboxGroup v-model="formValidate.sbtype" style="display: none"></CheckboxGroup>
        </FormItem>
    </div>

    <!--设备选择-->
    <div v-show="current == 2" style="margin-top: 30px;">
        <FormItem id="tf-form-item" label="设备选择" prop="sbselect">
            <ul v-if="list2.length > 0" class="select-type">
                <li v-for="(vo,index) in list2" :key="index" @click="onShebeiChange(vo,index)" :class="[formValidate.sbselect.indexOf(vo.did) >= 0 ? 'active' : '']">
                    <div><img :src="imgSrc+vo.dimg" alt=""><p style="font-size: 12px;">{{vo.dname}}</p></div>
                </li>
            </ul>
            <p style="text-align: center; padding: 20px 0; color:#cecece" v-else>暂无设备</p>
            <CheckboxGroup v-model="formValidate.sbselect" style="display: none"></CheckboxGroup>
        </FormItem>
    </div>
    <!--选择设备-->
    <div v-show="current == 3" style="margin-top: 30px;">
        <div v-if="formValidate.selectedEquipList.length > 0">
            <dl v-for="(item,index) in formValidate.selectedEquipList" :key="index" class="tf-cell" style="margin-bottom: 10px">
                <dt>{{index+1}}：已选设备</dt>
                <Collapse  accordion>
                    <Panel v-for="(vo,index2) in item.dswitch" :key="index2">
                        {{item.dname}}{{item.dswitchNum > 1 ? "-"+vo.name : ''}}
                        <div v-for="(node,i) in vo.nodeList" slot="content">
                            <div  style="padding-top: 15px;display: flex;">
                                <label style="padding-right: 10px;width: 70px">时间间隔<span
                                        style="color: #F00">*</span>
                                </label>
                                <div style="padding-right: 10px;">
                                    <TimePicker placement="top-start" v-model="node.time" format="HH:mm:ss" placeholder="请选择时间" style="width: 150px"></TimePicker>
                                </div >
                                <label style="padding-right: 10px;"> {{node.time}}秒后的状态<span
                                        style="color: #F00">*</span></label>
                                <div v-if="item.dinfo.eid.indexOf('kttg')!=-1" style="padding-right: 10px;width: 250px">
                                    <Slider v-model="node.gradual" :min="0" :max="50" :step="1" show-stops :tip-format="gradualFormat" style="margin-left:10px;width:200px"></Slider >
                                    <Slider v-model="node.deviceCondition" :min="0" :max="100" :step="10" show-stops :tip-format="tgFormat" style="margin-left:10px;width:200px"></Slider >
                                </div>
                                <div v-if="item.dinfo.eid.indexOf('ktts')!=-1" style="padding-right: 10px;">
                                    <Slider v-model="node.gradual" :min="0" :max="50" :step="1" show-stops :tip-format="gradualFormat" style="margin-left:10px;width:200px "></Slider >
                                    <color-picker v-model="node.deviceCondition"  style="margin-left:10px;"></color-picker>
                                </div>

                                <div v-if="item.dinfo.eid.indexOf('kt')==-1" style="padding-right: 10px;">
                                    <i-switch  v-model="node.deviceCondition" />
                                </div>
                                <Button v-if="item.dinfo.eid.indexOf('music')!=-1" @click="choose(item.dinfo,index,index2,i)"
                                        style="width:80px;margin-left:5px; top:-1px"  title="选择音乐">选择音乐</Button>
                                <Button v-if="vo.nodeList.length==1 || i!=0" @click="addNode(index,index2,i)"
                                        style="position: relative; margin-left:5px; top:-1px" icon="md-add" title="添加"
                                        size="small" type="primary"></Button>
                                <Button v-if="i!=0" @click="deleteNode(index,index2,i)"
                                        style="position: relative; margin-left:5px; top:-1px" icon="md-trash"
                                        title="删除" size="small" type="error"></Button>

                            </div>
                            <div v-if="item.dinfo.eid.indexOf('music')!=-1">
                                <label style="font-size: 14px;" v-model="node.deviceCondition">状态:{{ node.deviceCondition ? '播放':'停止' }};   </label>
                                <label style="font-size: 14px;" v-model="node.volume">音量:{{ node.volume }};  </label>
                                <label style="font-size: 14px;" v-model="node.cha">通道：{{ node.cha==0? '定阻':node.cha==1? '定压':'定阻定压'  }};  </label>
                                <label style="font-size: 14px;" v-model="node.path">歌曲：{{ node.path }}</label>
                            </div>
                        </div>
                    </Panel>
                </Collapse>
            </dl>
        </div>
        <p v-else style="text-align: center; padding: 20px 0; color:#cecece" >暂未选择设备</p>
    </div>

    <!--设置场景-->
    <div v-show="current == 4" style="margin-top: 30px;">
        <FormItem label="场景分类选择" prop="sceneCatId">
            <Select v-model="formValidate.sceneCatName" clearable label-in-value @on-change="sceneCatSelect" >
                <Option v-for="item in formValidate.sceneCatList" :value="item.sceneCatName" :key="item.sceneCatName">{{ item.sceneCatName }}</Option>
            </Select>
        </FormItem>
        <FormItem label="场景名称" prop="title">
            <Input :maxlength="10" v-model="formValidate.title" clearable placeholder="请输入场景名称"></Input>
        </FormItem>
        <FormItem label="场景图片" prop="pic">
            <div id="userpic" >
                <img class="userpic-pic" @click="addImg()" :src="[formValidate.pic == undefined || formValidate.pic == '' ? defaultPic : imgSrc+formValidate.pic]">
                <img class="userpic-xj" :src="xj" @click="addImg()">
                <input type="hidden" v-model="formValidate.pic">
                <Input v-model="formValidate.pic" style="display: none"></Input>
            </div>
        </FormItem>
    </div>

    </Form>
        <Row  v-if="picShow" v-model="picShow" id="sb-list" class-name="tf-row" type="flex" align="top" justify="space-between">
            <Card  id="myCard" :bordered="false" :dis-hover="true">
                <div class="myCard-head tf-center" slot="title">
                    <span class="myCard-title">选择图片</span>
                </div>
                <div class="myCard-con web-gailan overview">
                    <ul v-if="picList.length > 0" class="select-type">
                        <li  v-for="(vo,index2) in picList" :key="index2"  style="position:relative">
                            <div class="tthui">
                                <img @click="addIcon(vo.iconUrl)" :src="vo.iconUrl ? imgSrc+vo.iconUrl : nopic">
                            </div>
                        </li>
                    </ul>
                    <div v-else style="position: absolute; color: #ccc; top:40px; bottom: 0; left:0; right:0;"
                         class="tf-flex tf-flex-middle tf-flex-center">暂无图片
                    </div>
                </div>
            </Card>
        </Row>

        <!--右侧弹出窗口-->
        <div v-if="show">
            <Drawer @on-close="onClose" :title="winTitle" :width="400" v-model="show">
                <dscjMusic :sbinfo="sbInfo" @close="onClose"></dscjMusic>
            </Drawer>
        </div>

    <!--按钮-->
    <div class="demo-drawer-footer">
        <Button style="margin-right: 8px" @click="onCancel">取消</Button>
        <Button :loading="formValidate.btnLoading" type="primary" @click="onSubmit('formValidate')">{{!formValidate.btnLoading ? '确定' : '提交中...'}}</Button>
    </div>
    </div>
</template>

<script>
    import dj from '@/assets/img/lx/dj.png';
    import sb from '@/assets/img/lx/sb.png';
    import dcf from '@/assets/img/lx/dcf.png';
    import wxkzg from '@/assets/img/lx/wxkzg.png';
    import znmb from '@/assets/img/lx/znmb.png';
    import cgq from '@/assets/img/lx/cgq.png';
    import sxt from '@/assets/img/lx/sxt.png';

    import xj from '@/assets/img/tf_xj.png';
    import defaultPic from '@/assets/img/error_img.png';
    import cropperPic from '@/views/cropper';
    import dscjMusic from "@/views/znsb/music";

    export default {
        name: "dscj-add",
        components: {
            cropperPic,
            dscjMusic
        },
        props: ["itemval"],
        data()
        {
            //回调方法
            const validatecgqnumberset = (rule, value, callback) => {
                console.log(rule);
                console.log(this.cgqForm.valueStart);
                console.log(typeof(this.cgqForm.valueStart));
                console.log(typeof(this.cgqForm.valueShutdown));
                console.log(value);
                if (value == '')
                {
                    callback(new Error('数值必须设置'));
                }else{
                    var regu =/[^\d.]/g;
                    var re = new RegExp(regu);
                    if(re.test(value)){
                        callback(new Error('请输入数字或者小数'));
                    }else{
                        if(this.cgqForm.valueShutdown==this.cgqForm.valueStart && this.cgqForm.startSymbol==this.cgqForm.shutdownSymbol){
                            callback(new Error('开启值和关闭值、开启值大小关系和关闭值大小关系不能同时相等'));
                        }else{
                            callback();
                        }
                    }
                }
            };
            const validatecgqSymbol = (rule, value, callback) => {
                if(this.cgqForm.valueShutdown==this.cgqForm.valueStart && this.cgqForm.startSymbol==this.cgqForm.shutdownSymbol){
                    callback(new Error('开启值和关闭值、开启值大小关系和关闭值大小关系不能同时相等'));
                }else{
                    callback();
                }
            };
            const validateTimingRepeat = (rule, value, callback) => {
                console.log(value)
                if (value === true)
                {
                    if (this.dsForm.repeatTime.length > 0) {
//                        this.$refs.dsForm.validateField('repeatType');
//                        this.$refs.dsForm.validateField('repeatTime');
                        console.log('来了s')
                    }
                    callback();
                }else{
                    callback();
                }
            };

            const validateRepeatType = (rule, value, callback) => {

                if (value<= 0) {
                    callback(new Error('重复类型必须选择'));
                } else {
                    callback();
                }
            };
            const validateRepeatTime = (rule, value, callback) => {
                console.log(value)
                if (value.length <= 0 && this.dsForm.repeatType > 1) {
                    callback(new Error('星期、日期必须选择'));
                } else {
                    callback();
                }
            };

            const validateKdate = (rule, value, callback) => {
                console.log(value)
                if (value !== '')
                {
                    var dd = new Date();
                    var valuedd = new Date(value);
                    var nowDate = dd.getFullYear()+'-'+this.$func.addZero(dd.getMonth()+1)+'-'+this.$func.addZero(dd.getDate());
                    var valueDate = valuedd.getFullYear()+'-'+this.$func.addZero(valuedd.getMonth()+1)+'-'+this.$func.addZero(valuedd.getDate());
                    if(valueDate < nowDate){
                        callback(new Error('开启日期必须大于等于'+nowDate));
                    }else{
                        this.$refs.dsForm.validateField('ktime');
                        callback();
                    }
                } else {
                    callback();
                }
            };

            const validateKtime = (rule, value, callback) => {
                if (value !== '') {
                    var dd = new Date();
                    var nowDate = dd.getFullYear() + '-' + this.$func.addZero(dd.getMonth() + 1) + '-' + this.$func.addZero(dd.getDate());
                    var nowTime = this.$func.addZero(dd.getHours()) + ":" + this.$func.addZero(dd.getMinutes());
                    if (nowDate == this.dsForm.kdate) {
                        if (value < nowTime) {
                            callback(new Error('开启时间必须大于等于' + nowTime));
                        } else {
                            callback();
                        }
                    } else {
                        callback();
                    }
                } else {
                    callback(new Error('开启时间必须选择'));
                }
            };
            const validateJdate = (rule, value, callback) => {
                if (value !== '')
                {
                    var dd = new Date();
                    var valuedd = new Date(value);
                    var nowDate = dd.getFullYear()+'-'+this.$func.addZero(dd.getMonth()+1)+'-'+this.$func.addZero(dd.getDate());
                    var valueDate = valuedd.getFullYear()+'-'+this.$func.addZero(valuedd.getMonth()+1)+'-'+this.$func.addZero(valuedd.getDate());
                    if(valueDate < nowDate){
                        callback(new Error('结束日期必须大于等于'+nowDate));
                    }else{
                        this.$refs.dsForm.validateField('jtime');
                        callback();
                    }
                } else {
                    callback();
                }
            };

            const validateJtime = (rule, value, callback) => {
                if (value !== '') {
                    var dd = new Date();
                    var nowDate = dd.getFullYear() + '-' + this.$func.addZero(dd.getMonth() + 1) + '-' + this.$func.addZero(dd.getDate());
                    var nowTime = this.$func.addZero(dd.getHours()) + ":" + this.$func.addZero(dd.getMinutes());
                    if (nowDate == this.dsForm.jdate) {
                        if (value < nowTime) {
                            callback(new Error('结束时间必须大于等于' + nowTime));
                        } else {
                            callback();
                        }
                    } else {
                        callback();
                    }
                } else {
                    callback(new Error('结束时间必须选择'));
                }
            };

            return {
                picShow:false,
                picList:[],
                xj:xj,
                defaultPic:defaultPic,
                imgSrc:this.$func.imgSrc,

                box:[],//多选框
                //裁剪
                cropperShow:false,
                value1:'',
                //图片
                dj:dj,
                sb:sb,
                dcf:dcf,
                wxkzg:wxkzg,
                znmb:znmb,
                cgq:cgq,
                sxt:sxt,

                sceneType:'1',//1自动模式，2 手动模式
                //智慧喷灌
                floraCat:'',//植物类型
                isCheckMould:false,//是否匹配到
                isLoop:false,
                //索引
                current:0,
                switchValue: true,

                //表单
                formValidate: {
                    sbtype:[],
                    //设备数组
                    sbselect:[],
                    selectedEquipList:[],
                    sceneCatId: '',
                    sceneCatName:'',
                    sceneCatList:[],
                    title: '',
                    pic  : '',

                    btnLoading: false,

                },
                ruleValidate: {
                    sbtype: [
                        { required: true, type: 'array', min: 1, message: '分类必须选择', trigger: 'change' },
                    ],
                    sbselect: [
                        { required: true, type: 'array', min: 1, message: '设备必须选择', trigger: 'change' }
                    ],
                    sceneCatId: [
                        { required: true, message: '场景分类不能为空', trigger: 'blur' }
                    ],
                    title: [
                        { required: true, message: '场景名称不能为空', trigger: 'blur' }
                    ],

                },
                dsForm:{
                    //定时
                    kdate:'',
                    ktime:'',
                    jdate:'',
                    jtime:'',
                    timingRepeat:false,
                    repeatTime:[],
                    repeatTypeText:'',
                    repeatType:'',
                    gmtStart: '',
                    gmtEnd: '',
                },
                dsValidate:{
                    kdate: [
                        { validator: validateKdate, trigger: 'change' },
                    ],
                    ktime: [
                        { required: true, validator: validateKtime, trigger: 'change' },
                    ],
                    jdate: [
                        { validator: validateJdate, trigger: 'change' },
                    ],
                    jtime: [
                        { required: true, validator: validateJtime, trigger: 'change' },
                    ],
                    timingRepeat:[
                        { validator: validateTimingRepeat, trigger: 'change' }
                    ],
                    repeatType:[
                        {required: true, validator: validateRepeatType, trigger: 'change' }
                    ],
                    repeatTime:[
                        {validator: validateRepeatTime, trigger: 'change' }
                    ],
                },
                cgqForm:{

                    //关闭值
                    valueShutdown : '',
                    valueStart:'',
                    shutdownSymbol:'',
                    startSymbol:'',
                    valueType:'',
                    typeCurrent:0,

                    cgqsbtype:[],
                    cgqsbselect:[],
                    cgqkglist:[],

                },
                cgqValidate:{
                    cgqsbtype: [
                        { required: true, type: 'array', min: 1, message: '传感器分类必须选择', trigger: 'change' },
                    ],
                    cgqsbselect: [
                        { required: true, type: 'array', min: 1, message: '传感器设备必须选择', trigger: 'change' }
                    ],
                    valueStart: [
                        {required: true,  validator: validatecgqnumberset, trigger: 'change' },
                    ],
                    valueShutdown: [
                        {required: true,  validator: validatecgqnumberset, trigger: 'change' }
                    ],
                    startSymbol: [
                        {required: true,  validator: validatecgqSymbol, trigger: 'change' },
                    ],
                    shutdownSymbol: [
                        {required: true,  validator: validatecgqSymbol, trigger: 'change' }
                    ],
                },

                //列表
                list:[],
                //分类列表
                clist:[],
                list2:[],
                list3:[],

                //传感器
                cgqfllist:[],
                cgqsblist:[],
                cgqsblist3:[],
                floraCatList:[],
                sceneMouldList:[],
                symbolList:['<','=','>','<=','>='],
                repeatList:['每天','每周','每月'],
                data:['1','2','3','4','5','6','7','8','9','10','11','12','13','14','15','16','17','18','19','20','21','22','23','24','25','26','27','28','29','30'],
                //添加/编辑预加载数据
                preloading:true,
                //音乐选择侧边弹出
                show: false,
                sbInfo:'', //设备信息
                winTitle:'',

            };
        },
        computed: {

        },
        watch:{

            sceneMould(val, oldVal) {
                this.listenData(val,oldVal)
            },
        },
        created(){
            this.listSceneMould();
            this.getSceneCatList();
            this.getCarList();
            this.getIcon();
        },
        methods: {
            //关闭音乐侧滑返回
            onClose(status,volume,path,cha,index,index2,i){
                let that = this;
                this.show = false;
                if(status){
                    console.log(volume+path+cha)
                    that.formValidate.selectedEquipList[index].dswitch[index2].nodeList[i].deviceCondition=status==3 ? false: true;
                    that.formValidate.selectedEquipList[index].dswitch[index2].nodeList[i].volume=volume;
                    that.formValidate.selectedEquipList[index].dswitch[index2].nodeList[i].path=status==3 ? '': path;
                    that.formValidate.selectedEquipList[index].dswitch[index2].nodeList[i].cha=cha;
                }

            },
            addIcon(iconUrl){
                this.formValidate.pic=iconUrl;
            },
            //获取需要养护的
            getIcon(){
                let that = this;
                that.$func.ajax('listIcon',{
                },function (r) {
                    if(!r.statusCode){
                        that.$func.msg(r.message,'error');
                    }else {
                        that.picList = r.type;
                    }
                })
            },
            choose:function(vo,index,index2,i){
                const that = this;
                that.sbInfo = vo;
                that.sbInfo.modeType=1;
                that.sbInfo.index=index;
                that.sbInfo.index2=index2;
                that.sbInfo.i=i;
                console.log(vo)
                console.log(that.sbInfo)
                var ii=i+1
                that.winTitle = vo.deviceName+'-节点'+ii;
                that.show = true;
            },
            //添加节点
            addNode:function(index,index2,i) {
                console.log(i)
                console.log(this.formValidate.selectedEquipList[index].dswitch[index2].nodeList[i].time)
                if(i!=0&&this.formValidate.selectedEquipList[index].dswitch[index2].nodeList[i].time=='00:00:00'){//非第一个节点
                    this.$func.msg('非第一个节点时间间隔不能为00:00:00，请先完善','error');
                }else{
                    if(this.formValidate.selectedEquipList[index].dinfo.eid.indexOf('kttg')!=-1) { //凯图调光
                        this.formValidate.selectedEquipList[index].dswitch[index2].nodeList.splice(i, 0, {gradual:3,deviceCondition: 0, time: '00:00:00'});
                    }else if(this.formValidate.selectedEquipList[index].dinfo.eid.indexOf('ktts')!=-1) { //凯图调色
                        this.formValidate.selectedEquipList[index].dswitch[index2].nodeList.splice(i, 0, {gradual:3,deviceCondition: '#ffffff', time: '00:00:00'});
                    }else if(this.formValidate.selectedEquipList[index].dinfo.eid.indexOf('music')!=-1) { //音乐
                        this.formValidate.selectedEquipList[index].dswitch[index2].nodeList.splice(i, 0, {deviceCondition: true, path: '',volume: 20,cha: 2, time: '00:00:00'});
                    }else{
                        this.formValidate.selectedEquipList[index].dswitch[index2].nodeList.splice(i, 0, {deviceCondition: true, time: '00:00:00'});
                    }
                }

            },
            //删除节点
            deleteNode:function(index,index2,i) {
                this.formValidate.selectedEquipList[index].dswitch[index2].nodeList.splice(i,1);  //删除index为i,位置的数组元素
            },
            //监控数据变化
            listenData(val,oldVal){
                console.log(val+'***'+oldVal)
//                this.cgqForm.cgqnumberset = val;
//                if(this.isCheckMould && oldVal!='' && val!=''){
//                    this.$Modal.confirm({
//                        title: '确定要修改数值吗？系统提供的数值比较合理，请谨慎！',
//                        onOk: () => {
//
//                        }
//                    })
//                }
                //验证
                // this.$refs.formValidate.validate();
            },
            //week选择
            weekSelect(index){
                const that = this;
                if(that.dsForm.repeatTime.indexOf(index) >= 0){
                    that.dsForm.repeatTime.splice(that.dsForm.repeatTime.indexOf(index),1)
                }else{
                    that.dsForm.repeatTime.push(index)
                }
                //验证
                that.$refs.dsForm.validate();
            },
            tgFormat (val) {
                return '亮度' + val + '%';
            },
            gradualFormat (val) {
                return '渐变值' + val + '%';
            },
            tsFormat (val) {
                return val + '%';
            },
            //切换分类置空数据
            resetCgqData(){
                this.cgqForm.valueStart = '';
                this.cgqForm.valueShutdown='';
                this.cgqForm.startSymbol = '';
                this.cgqForm.shutdownSymbol='';
                this.cgqForm.typeCurrent = 0;
            },

            addImg()
            {
                let that = this;
                //显示选择图片
                console.log('点击')
                that.picShow = !that.picShow;

            },

            // 获取数据模板
            listSceneMould(){
                var that=this;
                that.$func.ajax('listSceneMould', {
                    sceneCat:that.sceneCat
                }, function (r) {
                    if (r.statusCode) {//有记录
                        that.sceneMouldList = r.type;
                        that.sceneMouldList.map(function (item) {//过滤重复
                            if (that.floraCatList.indexOf(item.floraCat)==-1){
//                                console.log('获取喷灌模板'+item.floraCat);
                                that.floraCatList.push(item.floraCat);
                            }
                        })
                    }
                });
            },
            //植物下拉选择
            onSelect(val){
                if(val){//排除清空时触发
                    console.log(val);
                    this.floraCat=val.value;
                    // todo 2019-06-11模型匹配
                    this.resetCgqData();
                    this.checkMould();
                }
            },
            catClear(){//清空植物下拉
                var that = this;
                that.resetCgqData();
            },
            //场景分类选择
            sceneCatSelect(val){
                var that = this;
                console.log(val);
                that.formValidate.sceneCatName=val.value;
                that.formValidate.sceneCatList.map(function(item,index){
                    if(item.sceneCatName == val.value){
                        that.formValidate.sceneCatId=item.sceneCatId;
                    }
                })
                console.log(that.formValidate.sceneCatId);

            },
            //重复类型选择
            repeatTypeSelect(val){
                var that = this;
                console.log(val);
                that.repeatList.map(function(item,index){
                    if(item == val.value){
                        that.dsForm.repeatType=index+1;
                    }
                })

                console.log(that.dsForm.repeatType);

            },
            //获取场景分类
            getSceneCatList(){
                var that = this;
                that.$func.ajax('listSceneCat',{
                    token:that.$func.getToken()
                },function(r){
                    if(!r.statusCode){
                        that.$func.msg(r.message,'error');
                    }else{
                        that.formValidate.sceneCatList= r.type;
                    }

                })
            },
            //模型匹配,3个地方调用：植物类型改变、数值类型改变、传感器设备改变
            checkMould(){
                var that=this;
                this.cgqForm.cgqkglist.map(function (item) {
                    if(item.dinfo.eid == 3) {//湿度传感器
                        that.cgqForm.valueType='sd';
                    }else if(item.dinfo.eid == 4){ //湿温盐传感器
                        if(that.cgqForm.typeCurrent==0){
                            that.cgqForm.valueType='sd';
                        }else  if(that.cgqForm.typeCurrent==1){
                            that.cgqForm.valueType='wd';
                        }else {
                            that.cgqForm.valueType='yf';
                        }
                    }else if(item.dinfo.eid == 5 || item.dinfo.eid == 15){//温湿度传感器、空气温湿盐传感器
                        if(that.cgqForm.wsdCurrent==0){
                            that.cgqForm.valueType='sd';
                        }else {
                            that.cgqForm.valueType='wd';
                        }
                    }else if(item.dinfo.eid == 24){//水位传感器
                        that.cgqForm.valueType='sw';
                    }else{//精讯传感器
                        that.cgqForm.valueType=item.dinfo.eid.split('-')[1];
                    }
                })

                that.isCheckMould=false;
                this.sceneMouldList.map(function (item) {
                    // todo 2019-06-11 植物名相同且选中的值类型相同（ws和wsy可能会混乱）
                    if(item.floraCat==that.floraCat&&item.valueType==that.cgqForm.valueType){
                        console.log('匹配到模板：'+JSON.stringify(item));
                        that.isCheckMould=true;
                        that.cgqForm.valueStart = item.openValue;
                        that.cgqForm.valueShutdown=item.closeValue;
                        that.cgqForm.startSymbol = item.startSymbol;
                        that.cgqForm.shutdownSymbol=item.shutdownSymbol;
                        console.log(that.cgqForm.valueStart+'&&&'+that.cgqForm.valueShutdown);
                    }
                })
            },
            //切换 传感器 - 分类
            onCgqFenleiChange(vo,index2){
                const that = this;
                that.resetCgqData();
                if(that.cgqForm.cgqsbtype.indexOf(vo.cid) >= 0)
                {
                    that.cgqForm.cgqsbtype.splice(that.cgqForm.cgqsbtype.indexOf(vo.cid),1);
                    that.cgqsblist3.map(function(item,index){
                        if(item.pid == vo.cid)
                        {
                            //删除设备
                            if(that.cgqsblist.length > 0)
                            {
                                that.cgqsblist.map(function(item3,index3){
                                    if(item.did == item3.did){
                                        that.cgqsblist.splice(index3,1);
                                    }
                                })
                            }
                            //删除开关
                            if(that.cgqForm.cgqkglist.length > 0)
                            {
                                that.cgqForm.cgqkglist.map(function(item3,index3){
                                    if(item.did == item3.did){
                                        that.cgqForm.cgqsbselect.splice(index3,1);
                                        that.cgqForm.cgqkglist.splice(index3,1);
                                    }
                                })
                            }
                        }
                    })
                }else{
                    that.cgqForm.cgqsbtype.push(vo.cid);
                    that.cgqsblist3.map(function(item,index){
                        if(item.pid == vo.cid){
                            that.cgqsblist.push({
                                did  :item.did,
                                dname:item.dname,
                                dimg :item.dimg,
                                dinfo:item.dinfo
                            })
                        }
                    })
                }
                //验证
                that.$refs.formValidate.validate();
            },

            //切换 传感器 - 设备
            onCgqShebeiChange(vo,index2){
                const that = this;
                that.resetCgqData();
                that.cgqForm.cgqsbselect = [];
                that.cgqForm.cgqkglist = [];
                if(that.cgqForm.cgqsbselect.indexOf(vo.did) >= 0)
                {
                    that.cgqForm.cgqsbselect.splice(that.cgqForm.cgqsbselect.indexOf(vo.did),1);
                    if(that.cgqForm.cgqkglist.length > 0)
                    {
                        that.cgqForm.cgqkglist.map(function(item,index){
                            if(vo.did == item.did){
                                that.v.cgqkglist.splice(index,1);
                            }
                        })
                    }
                }else{
                    that.cgqForm.cgqsbselect.push(vo.did);
                    that.cgqForm.cgqkglist.push(vo);
                }
                // todo 2019-06-21模型匹配，赋值先后顺序乱了
                setTimeout(function () {
                    that.checkMould();
                }, 500)
                //验证
//                that.$refs.formValidate.validate();

            },

            //切换分类
            onFenleiChange(vo,index2){
                const that = this;
                if(that.formValidate.sbtype.indexOf(vo.cid) >= 0)
                {
                    that.formValidate.sbtype.splice(that.formValidate.sbtype.indexOf(vo.cid),1);
                    that.list3.map(function(item,index){
                        if(item.pid == vo.cid)
                        {
                            //删除设备
                            if(that.list2.length > 0)
                            {
                                that.list2.map(function(item3,index3){
                                    if(item.did == item3.did){
                                        that.list2.splice(index3,1);
                                    }
                                })
                            }
                            //删除开关
                            if(that.formValidate.selectedEquipList.length > 0)
                            {
                                that.formValidate.selectedEquipList.map(function(item3,index3){
                                    if(item.did == item3.did){
                                        that.formValidate.sbselect.splice(index3,1);
                                        that.formValidate.selectedEquipList.splice(index3,1);
                                    }
                                })
                            }
                        }
                    })
                }else{
                    that.formValidate.sbtype.push(vo.cid);
                    that.list3.map(function(item,index){
                        if(item.pid == vo.cid){
                            that.list2.push({
                                did  :item.did,
                                dname:item.dname,
                                dimg :item.dimg,
                                dswitch:item.dswitch,
                                dswitchNum:item.dswitchNum,
                                dswitchStatus:item.dswitchStatus,
                                dinfo:item.dinfo
                            })
                        }
                    })
                }
                //验证
                that.$refs.formValidate.validate();
            },

            //切换设备
            onShebeiChange(vo,index2){
                const that = this;
                if(that.formValidate.sbselect.indexOf(vo.did) >= 0)
                {
                    that.formValidate.sbselect.splice(that.formValidate.sbselect.indexOf(vo.did),1);
                    if(that.formValidate.selectedEquipList.length > 0)
                    {
                        that.formValidate.selectedEquipList.map(function(item,index){
                            if(vo.did == item.did){
                                that.formValidate.selectedEquipList.splice(index,1);
                            }
                        })
                    }
                }else{
                    that.formValidate.sbselect.push(vo.did);
                    that.formValidate.selectedEquipList.push(vo)
                }
                console.log(vo)
                //验证
                that.$refs.formValidate.validate();
            },

            //获取设备分类
            getCarList()
            {
                const that = this;
                that.$func.ajax('catList',{
                    catPosition:3,
                    flag:1,
                    token:that.$func.getToken(),
                    areaId:that.$store.state.app.areaId
                },function (r) {
                    if(!r.statusCode){
                        that.$func.msg(r.message,'error');
                    }else{
                        that.list = r.type;
                        console.log(that.list);
                        r.type.map(function (vo,index)
                        {
                            vo.devices.map(function (vo2,index2)
                            {
                                //传感器 判断
                                if(vo.catFlag == 1 && vo.devices.length > 0 && vo2.factoryType != 2)
                                {
                                    if(index2 == vo.devices.length-1){
                                        that.cgqfllist.push({
                                            cid  : vo.catId,
                                            cname: vo.catName,
                                            cimg : vo.catImg
                                        });
                                    }

                                    that.cgqsblist3.push({
                                        pid  :vo.catId,
                                        did  :vo2.deviceId,
                                        dname:vo2.deviceName,
                                        dimg :vo2.deviceImg,
                                        dinfo:vo2
                                    })
                                }

                                //判断只获取 天正和 灯控设备 凯图 精讯 芯蚁
                                if(vo.catFlag == 2 && vo.devices.length > 0 && vo2.factoryType != 2 )
                                {
                                    if(index2 == vo.devices.length-1){
                                        that.clist.push({
                                            cid  : vo.catId,
                                            cname: vo.catName,
                                            cimg : vo.catImg
                                        });
                                    }

                                    //判断是否天正
                                    if(vo2.factoryType == 1){ //天正
                                        //判断设备是否开机
                                        that.$func.tz.getDevideInfo(vo2.deviceMac,function(res)
                                        {
                                            if(res && res.eqmsg){
                                                //首先格式化消息
                                                if(res.eqmsg.split(',').length > 1) //多数据 可能存在 多路
                                                {
                                                    //判断是否是控制器
                                                    that.list[index].devices[index2].switch = [];
                                                    res.eqmsg.split(',').map(function(vv,ii)
                                                    {
                                                        //是开关
                                                        if(that.$store.state.app.tz.offCode.indexOf(vv) > -1 || that.$store.state.app.tz.onCode.indexOf(vv) > -1){
                                                            that.list[index].devices[index2].switchNum = res.eqmsg.split(',').length;
                                                            that.list[index].devices[index2].switch[ii] = {
                                                                name:(ii+1)+'路',
                                                                value:vv,
                                                                nodeList:[{deviceCondition: true, time: '00:00:00'}]
                                                            };
                                                            //不是开关
                                                        }else{
                                                            that.list.splice(index,1);
                                                        }
                                                    })
                                                    that.list[index].devices[index2].switchStatus = false;

                                                }else //单数据
                                                {

                                                    if(that.$store.state.app.tz.offCode.indexOf(res.eqmsg) > -1 ||that.$store.state.app.tz.onCode.indexOf(res.eqmsg) > -1){
                                                        that.list[index].devices[index2].switchNum = 1;
                                                        that.list[index].devices[index2].switchStatus = false;
                                                        that.list[index].devices[index2].switch = [
                                                            {
                                                                name:'1路',
                                                                value:res.eqmsg,
                                                                nodeList:[{deviceCondition: true, time: '00:00:00'}]
                                                            }
                                                        ];
                                                    }else{
                                                        that.list[index].devices[index2].switchNum = 0;
                                                    }
                                                }

                                                that.list3.push({
                                                    pid  :vo.catId,
                                                    did  :vo2.deviceId,
                                                    dname:vo2.deviceName,
                                                    dimg :vo2.deviceImg,
                                                    dswitch:vo2.switch,
                                                    dswitchNum:vo2.switchNum,
                                                    dswitchStatus:vo2.switchStatus,
                                                    dinfo:vo2
                                                })
                                            }else{
                                                that.$func.notice('【'+vo2.deviceName+'】设备接口异常，禁止操作，请联系管理员！','error');
                                                that.$emit('close');
                                            }
                                        },function () {
                                            that.$func.notice('【'+vo2.deviceName+'】设备接口异常，禁止操作，请联系管理员！','error');
                                            that.$emit('close');
                                        })

                                    }else if(vo2.factoryType == 3){ //晶控
                                        that.list[index].devices[index2].status = true;
                                        if(vo2.isGroup==0){//单个设备
                                            //判断灯具和智能面板
                                            if(vo2.eid == 'dj') //灯具
                                            {
                                                that.list[index].devices[index2].switchNum = 1;
                                                that.list[index].devices[index2].switchStatus = false;
                                                that.list[index].devices[index2].switch = [
                                                    {
                                                        name:'1路',
                                                        value:'',
                                                        nodeList:[{deviceCondition: true, time: '00:00:00'}]
                                                    }
                                                ];
                                            }else if(vo2.eid == 'znmb') //智能面板
                                            {
                                                //按钮名称
                                                var remarkArr = vo2.remark.split('\r\n');
                                                //判断设备
                                                var lens = remarkArr.length;
                                                //判断开关
                                                that.list[index].devices[index2].switchNum = lens;
                                                that.list[index].devices[index2].switchStatus = false;
                                                //反编译开关
                                                var lensswitchs1 = [];
                                                for(let ii = 0; ii<lens; ii++){
                                                    lensswitchs1.push({
                                                        name:remarkArr[ii],
                                                        value:'',
                                                        nodeList:[{deviceCondition: true, time: '00:00:00'}]
                                                    })
                                                }
                                                that.list[index].devices[index2]. switch = lensswitchs1;
                                            }
                                        }else {//组合设备
                                            that.list[index].devices[index2].switchNum = 1;
                                            that.list[index].devices[index2].switchStatus = false;
                                            that.list[index].devices[index2].switch = [
                                                {
                                                    name:'组合开关',
                                                    value:'',
                                                    nodeList:[{deviceCondition: true, time: '00:00:00'}]
                                                }
                                            ];
                                        }


                                        that.list3.push({
                                            pid  :vo.catId,
                                            did  :vo2.deviceId,
                                            dname:vo2.deviceName,
                                            dimg :vo2.deviceImg,
                                            dswitch:vo2.switch,
                                            dswitchNum:vo2.switchNum,
                                            dswitchStatus:vo2.switchStatus,
                                            dinfo:vo2
                                        })

                                    }else if(vo2.factoryType == 4){ //凯图
//                                        console.log(vo2)
                                        //反编译开关
                                        var lensswitchs1 = [];
                                        //判断设备路数
                                        var lens = that.$KtApi.getKtSwitchNum(vo2.eid);
                                        if(that.$KtApi.isSetBright(vo2.eid)){//调光
                                            that.list[index].devices[index2].switchNum = lens;
                                            that.list[index].devices[index2].switchStatus =false;
                                            for(let ii = 0; ii<lens; ii++){
                                                lensswitchs1.push({
                                                    name:(ii+1)+'路',
                                                    value:'',
                                                    nodeList:[{gradual:3,deviceCondition: 0, time: '00:00:00'}]
                                                })
                                            }
                                            that.list[index].devices[index2].switch = lensswitchs1;
                                        }
                                        if(that.$KtApi.isSetColor(vo2.eid)){//调色
                                            that.list[index].devices[index2].switchNum = 1;
                                            that.list[index].devices[index2].switchStatus =false;
                                            that.list[index].devices[index2].switch = [
                                                {
                                                    name:'1路',
                                                    value:'',
                                                    nodeList:[{gradual:3,deviceCondition: '#ffffff', time: '00:00:00'}]
                                                }
                                            ];

                                        }


                                        that.list3.push({
                                            pid  :vo.catId,
                                            did  :vo2.deviceId,
                                            dname:vo2.deviceName,
                                            dimg :vo2.deviceImg,
                                            dswitch:vo2.switch,
                                            dswitchNum:vo2.switchNum,
                                            dswitchStatus:vo2.switchStatus,
                                            dinfo:vo2
                                        })
                                    }else if(vo2.factoryType == 5){ //精讯
//                                        console.log(vo2)
                                        that.list[index].devices[index2].status = true;
                                        if(vo2.isGroup==0){//单个设备
                                            if(that.$func.isRelay(vo2.eid)) //继电器
                                            {
                                                //按钮名称
                                                var remarkArr = vo2.remark.split('\r\n');
                                                //判断设备
                                                var lens = remarkArr.length;
                                                //判断开关
                                                that.list[index].devices[index2].switchNum = lens;
                                                that.list[index].devices[index2].switchStatus = false;
                                                //反编译开关
                                                var lensswitchs1 = [];
                                                for(let ii = 0; ii<lens; ii++){
                                                    lensswitchs1.push({
                                                        name:remarkArr[ii],
                                                        value:'',
                                                        nodeList:[{deviceCondition: true, time: '00:00:00'}]
                                                    })
                                                }
                                                that.list[index].devices[index2]. switch = lensswitchs1;
                                            }
                                        }else {//组合设备
                                            that.list[index].devices[index2].switchNum = 1;
                                            that.list[index].devices[index2].switchStatus = false;
                                            that.list[index].devices[index2].switch = [
                                                {
                                                    name:'组合开关',
                                                    value:'',
                                                    nodeList:[{deviceCondition: true, time: '00:00:00'}]
                                                }
                                            ];
                                        }


                                        that.list3.push({
                                            pid  :vo.catId,
                                            did  :vo2.deviceId,
                                            dname:vo2.deviceName,
                                            dimg :vo2.deviceImg,
                                            dswitch:vo2.switch,
                                            dswitchNum:vo2.switchNum,
                                            dswitchStatus:vo2.switchStatus,
                                            dinfo:vo2
                                        })
                                    }else if(vo2.factoryType == 6){ //芯蚁
//                                        console.log(vo2)
                                        that.list[index].devices[index2].status = true;
                                        if(that.$func.isRelay(vo2.eid)|| vo2.eid.indexOf('valve') != -1) {//继电器、电磁阀
                                            if(vo2.isGroup==0){//单个设备
                                                //按钮名称
                                                var remarkArr = vo2.remark.split('\r\n');
                                                //判断设备
                                                var lens = remarkArr.length;
                                                //判断开关
                                                that.list[index].devices[index2].switchNum = lens;
                                                that.list[index].devices[index2].switchStatus = false;
                                                //反编译开关
                                                var lensswitchs1 = [];
                                                for(let ii = 0; ii<lens; ii++){
                                                    lensswitchs1.push({
                                                        name:remarkArr[ii],
                                                        value:'',
                                                        nodeList:[{deviceCondition: true, time: '00:00:00'}]
                                                    })
                                                }
                                                that.list[index].devices[index2]. switch = lensswitchs1;
                                            }else {//组合设备
                                                that.list[index].devices[index2].switchNum = 1;
                                                that.list[index].devices[index2].switchStatus = false;
                                                that.list[index].devices[index2].switch = [
                                                    {
                                                        name:'组合开关',
                                                        value:'',
                                                        nodeList:[{deviceCondition: true, time: '00:00:00'}]
                                                    }
                                                ];
                                            }

                                        }else if(vo2.eid.indexOf('kt') != -1) {//调色、调光
                                            //反编译开关
                                            var lensswitchs1 = [];
                                            //判断设备路数
                                            var lens = that.$KtApi.getKtSwitchNum(vo2.eid);
                                            if(that.$KtApi.isSetBright(vo2.eid)){//调光
                                                that.list[index].devices[index2].switchNum = lens;
                                                that.list[index].devices[index2].switchStatus =false;
                                                for(let ii = 0; ii<lens; ii++){
                                                    lensswitchs1.push({
                                                        name:(ii+1)+'路',
                                                        value:'',
                                                        nodeList:[{gradual:3,deviceCondition: 0, time: '00:00:00'}]
                                                    })
                                                }
                                                that.list[index].devices[index2].switch = lensswitchs1;
                                            }
                                            if(that.$KtApi.isSetColor(vo2.eid)){//调色
                                                that.list[index].devices[index2].switchNum = 1;
                                                that.list[index].devices[index2].switchStatus =false;
                                                that.list[index].devices[index2].switch = [
                                                    {
                                                        name:'1路',
                                                        value:'',
                                                        nodeList:[{gradual:3,deviceCondition: '#ffffff', time: '00:00:00'}]
                                                    }
                                                ];

                                            }
                                        }else if(vo2.eid.indexOf('music') != -1) {//音乐
                                            that.list[index].devices[index2].switchNum = 1;
                                            that.list[index].devices[index2].switchStatus = false;
                                            that.list[index].devices[index2].switch = [
                                                {
                                                    name:'1路',
                                                    value:'',
                                                    nodeList:[{deviceCondition: true, path: '',volume: 20,cha: 2, time: '00:00:00'}]
                                                }
                                            ];
                                        }

                                        that.list3.push({
                                            pid  :vo.catId,
                                            did  :vo2.deviceId,
                                            dname:vo2.deviceName,
                                            dimg :vo2.deviceImg,
                                            dswitch:vo2.switch,
                                            dswitchNum:vo2.switchNum,
                                            dswitchStatus:vo2.switchStatus,
                                            dinfo:vo2
                                        })
                                    }


                                }
                            })
                        })

                        if(that.itemval!=''){//编辑
                            //显示回显数据
                            that.huiXian();
                        }else{//添加
                            //预加载结束
                            that.preloading = false;
                        }
                    }
                })
            },
            //获取回显
            huiXian()
            {
                console.log('编辑场景')
                let that = this;
                that.$func.ajax('sceneDetail',{
                    sceneId:that.itemval.sceneId,
                },function(r){
                    if(!r.statusCode){
                        that.$func.msg(r.message,'error');
                    }else{

                        //表单数据
                        if(r.type.sceneName)     that.formValidate.title = r.type.sceneName;
                        if(r.type.sceneImg)      that.formValidate.pic   = r.type.sceneImg;
                        if(r.type.sceneType)     that.sceneType = r.type.sceneType+'';
                        if(r.type.isLoop)     that.isLoop=r.type.isLoop==1? true:false;
                        if(r.type.timingRepeat) {
                            that.dsForm.timingRepeat = r.type.timingRepeat==1? true:false;
                            that.dsForm.repeatType=r.type.repeatType;
                            that.dsForm.repeatTypeText=that.repeatList[r.type.repeatType-1];
                        }
                        if(r.type.repeatTime){
                            that.dsForm.repeatTime  = r.type.repeatTime.split(',');
                            that.dsForm.repeatTime.map(function(vo,index){//字符转数字
                                that.dsForm.repeatTime[index]=parseInt(vo);
                            })
                        }
                        if(r.type.gmtStart){
                            that.box.push('ds');
                            that.dsForm.kdate = r.type.gmtStart.split(' ')[0];
                            that.dsForm.ktime = r.type.gmtStart.split(' ')[1];
                        }
                        if(r.type.gmtEnd){
                            that.dsForm.jdate  = r.type.gmtEnd.split(' ')[0];
                            that.dsForm.jtime = r.type.gmtEnd.split(' ')[1];
                        }
                        if(r.type.sceneCatId){
                            that.formValidate.sceneCatId = r.type.sceneCatId;
                            that.formValidate.sceneCatList.map(function(item,index){
                                if(item.sceneCatId == r.type.sceneCatId){
                                    that.formValidate.sceneCatName=item.sceneCatName;
                                }
                            })
                        }

                        //传感器
                        if(typeof(r.type.sensor) != 'undefined')
                        {
//                            console.log(r.type.sensor)
                            that.box.push('cgq');
                            that.cgqsblist3.map(function(item,index2)
                            {
                                if(r.type.sensor.deviceId == item.did)
                                {
                                    that.cgqForm.valueType=r.type.sensor.valueType;
                                    that.floraCat=r.type.sensor.floraCat;
                                    if(that.cgqForm.valueType == 'sd' && r.type.sensor.factoryType == 1) {//湿度、天正
                                        that.cgqForm.valueStart=Number((Number(r.type.sensor.valueStart)*100).toFixed(8))+'';
                                        that.cgqForm.valueShutdown=Number((Number(r.type.sensor.valueShutdown)*100).toFixed(8))+'';
                                    }else {
                                        that.cgqForm.valueStart=r.type.sensor.valueStart;
                                        that.cgqForm.valueShutdown=r.type.sensor.valueShutdown;
                                    }
                                    that.cgqForm.startSymbol=r.type.sensor.startSymbol;
                                    that.cgqForm.shutdownSymbol=r.type.sensor.shutdownSymbol;
                                    if(item.dinfo.eid == 4){ //湿温盐传感器
                                        if(that.cgqForm.valueType=='sd'){
                                            that.cgqForm.typeCurrent==0;
                                        }else  if(that.cgqForm.valueType=='wd'){
                                            that.cgqForm.typeCurrent==1;
                                        }else {
                                            that.cgqForm.typeCurrent==2;
                                        }
                                    }else if(item.dinfo.eid == 5 || item.dinfo.eid == 15){//温湿度传感器、空气温湿盐传感器
                                        if(that.cgqForm.valueType=='sd'){
                                            that.cgqForm.typeCurrent==0;
                                        }else {
                                            that.cgqForm.typeCurrent==1;
                                        }
                                    }else{//精讯
                                        that.cgqForm.typeCurrent==0;
                                    }

                                    var newData2 = {
                                        did  :item.did,
                                        dname:item.dname,
                                        dimg :item.dimg,
                                        dinfo:item.dinfo
                                    };
                                    if(that.cgqForm.cgqsbtype.indexOf(item.dinfo.catId) === -1){
                                        that.cgqForm.cgqsbtype.push(item.dinfo.catId);
                                    }
                                    if(that.cgqForm.cgqsbselect.indexOf(item.did) === -1){
                                        that.cgqForm.cgqsbselect.push(item.did);
                                    }
                                    that.cgqForm.cgqkglist.push(newData2);
                                    that.cgqsblist3.map(function(vo5,index5){
                                        that.cgqsblist.push(vo5)
                                    })
                                }
                            })

                        }
                        //设备
                        r.type.sceneDeviceList.map(function(vo,index)
                        {
                            //其他设备
                            that.list3.map(function(item,index2){

                                if(vo.deviceId == item.did)
                                {
                                    console.log(vo)
                                    console.log(item)
                                    that.list3[index2].dswitch[vo.wire-1].nodeList=JSON.parse(vo.nodeList);
                                    that.list3[index2].dswitch[vo.wire-1].nodeList.map(function (item3,index3) {//格式转换
                                        // 2019-07-12 不转换开关类型  开关ui显示异常
                                        if (item3.deviceCondition=='false'){
                                            item3.deviceCondition=false
                                        }
                                        if (item3.deviceCondition=='true'){
                                            item3.deviceCondition=true
                                        }
                                        if(item.dinfo.eid.indexOf('kttg')!=-1){
                                            item3.deviceCondition=parseInt(item3.deviceCondition);
                                        }
                                    })
                                    var newData = {
                                        did  :item.did,
                                        dname:item.dname,
                                        dimg :item.dimg,
                                        dswitch:that.list3[index2].dswitch,
                                        dswitchNum:item.dswitchNum,
                                        dswitchStatus:item.dswitchStatus,
                                        dinfo:item.dinfo
                                    };
                                    if(that.formValidate.sbtype.indexOf(item.dinfo.catId) === -1){
                                        that.formValidate.sbtype.push(item.dinfo.catId);
                                    }
                                    if(that.formValidate.sbselect.indexOf(item.did) === -1){
                                        that.formValidate.sbselect.push(item.did);
                                        that.list2.push(newData)
                                        that.formValidate.selectedEquipList.push(newData);
                                    }
                                }
                            })

                        })
                        //预加载结束
                        that.preloading = false;
                    }
                })
            },

            onCancel(){
                this.$emit('close');
            },
            //向上提交
            onSubmit(name) {
                const that = this;
                if(that.cgqForm.valueType == 'hw'){
                    console.log('红外');
                    that.cgqForm.valueStart=1;
                    that.cgqForm.valueShutdown=0;
                }
                //验证表单
                that.$refs[name].validate(valid => {
                    if (valid)
                    {
                        //按钮状态关闭
                        that[name].btnLoading = true
                        //设备数组，传感器数组
                        var deviceList = [];
                        var sensorData = '';
                        if(that.sceneType==1){//自动
                            if(that.box.indexOf('cgq')!=-1){//cgqForm勾选了传感器
                                that.$refs['cgqForm'].validate(valcgq => {//传感器表单验证
                                    if (valcgq) {

                                        //添加传感器
                                        that.cgqForm.cgqkglist.map(function(item,index){
                                            if(that.cgqForm.valueType == 'sd' && item.dinfo.factoryType == 1) {//湿度、天正
                                                that.cgqForm.valueStart=Number((Number(that.cgqForm.valueStart)/100).toFixed(8));
                                                that.cgqForm.valueShutdown=Number((Number(that.cgqForm.valueShutdown)/100).toFixed(8));
                                            }
                                            sensorData={
                                                "deviceId"  : item.did,//设备编号
                                                "factoryType": item.dinfo.factoryType, //厂家
                                                "deviceMac" : item.dinfo.deviceMac,//设备地址
                                                "netMac"    : item.dinfo.netMac,//网关地址
                                                "valueShutdown" : that.cgqForm.valueShutdown,
                                                "valueStart": that.cgqForm.valueStart,
                                                "shutdownSymbol" : that.cgqForm.shutdownSymbol,
                                                "startSymbol": that.cgqForm.startSymbol,
                                                "eid":item.dinfo.eid,
                                                "floraCat" :that.floraCat,
                                                "valueType":that.cgqForm.valueType
                                            };
                                        })
                                    } else{
                                        that.$func.msg('传感器部分填写有误，请检查！','error');
                                    }
                                })
                            }
                            if(that.box.indexOf('ds')!=-1){//dsForm勾选了定时
                                that.$refs['dsForm'].validate(valds => {//定时表单验证
                                    if (valds) {
                                        //设置了定时
                                        that.dsForm.gmtStart=that.$func.formatDate(that.dsForm.kdate,"yyyy-MM-dd")+' '+that.dsForm.ktime;
                                        that.dsForm.gmtEnd=that.$func.formatDate(that.dsForm.jdate,"yyyy-MM-dd")+' '+that.dsForm.jtime;
                                    }else{
                                        that.$func.msg('定时部分填写有误，请检查！','error');
                                    }
                                })
                            }
                        }else{//手动，清空定时、传感器
                            that.dsForm.gmtStart='';
                            that.dsForm.gmtEnd='';
                            that.dsForm.timingRepeat='';
                            that.dsForm.repeatTime=[];
                            that.dsForm.repeatType=0;
                            sensorData='';
                        }

                        var isTrue=true;
                        //设备
                        that.formValidate.selectedEquipList.map(function(vo,index){
                            var num=0;
                            vo.dswitch.map(function(vo2,index2)
                            {
                                var zq=true;
                                vo2.nodeList.map(function(node,index3) {
                                    if(index3!=0 && node.time=='00:00:00'){//非第一个节点
                                        zq=false;
                                        isTrue=false;
                                        that.$func.msg('非第一个节点时间间隔不能为00:00:00','error');
                                    }
                                })
                                if(vo2.nodeList.length==1&& (vo2.nodeList[0].deviceCondition=='#ffffff' || vo2.nodeList[0].deviceCondition==false ||vo2.nodeList[0].deviceCondition==0)){
                                    zq=false;
                                }
                                if(zq){
                                    num++;
                                    deviceList.push({
                                        "deviceId"  : vo.did,//设备编号
                                        "deviceName"  : vo.dname,
                                        "factoryType": vo.dinfo.factoryType, //厂家
                                        "deviceMac" : vo.dinfo.deviceMac,//设备地址
                                        "netMac"    : vo.dinfo.netMac,//网关地址
                                        "appendData": "这里是附加的json",
                                        "eid": vo.dinfo.eid,
                                        "wireCount":vo.dswitchNum,
                                        "wire":index2+1,
                                        "nodeList":vo2.nodeList ,

                                    });
                                }
                            })
                            if(num==0){
                                isTrue=false;
                                that.$func.msg('设备：【'+vo.dname+'】未设置设备状态,时间间隔不能为00:00:00','error');
                            }
                        })

                        console.log(that.box.length);
                        if(that.sceneType==1 && that.box.length==0){//自动，没有定时，没有传感器，不合法
                            that.$func.msg('自动模式，必须设置定时或者传感器','error');
                            //按钮状态开启
                            that[name].btnLoading = false
                        }else{
                            if(isTrue==false|| deviceList.length<that.formValidate.selectedEquipList.length){//设备节点有问题,或设备数不等于节点集合数
                                that.$func.msg('未设置设备状态或设备状态存在问题，请检查','error');
                                //按钮状态开启
                                that[name].btnLoading = false
                            }else{
                                //组合新数据
                                var newData = {
                                    token       : that.$func.getToken(),
                                    sceneId     : that.itemval.sceneId,
                                    sceneCatId  : that.formValidate.sceneCatId,
                                    sceneName   : that.formValidate.title,
                                    sceneImg    : that.formValidate.pic,
                                    areaId:that.$store.state.app.areaId,
                                    sceneType:that.sceneType,
                                    timingRepeat:that.dsForm.timingRepeat==true ? 1:2,
                                    isLoop : that.isLoop==true ? 1:2,
                                    repeatType:that.dsForm.repeatType,
                                    repeatTime: that.dsForm.repeatTime.sort(function(a,b){ return a-b;}).join(','),
                                    gmtStart: that.dsForm.gmtStart,
                                    gmtEnd: that.dsForm.gmtEnd,
                                    sceneDeviceList  : deviceList,
                                    sensor:sensorData
                                };

                                console.log('deviceList ='+JSON.stringify(deviceList));
                                console.log('newData ='+JSON.stringify(newData));
                                that.$func.ajax('sceneSave',newData,function(r){
                                    //按钮状态开启
                                    that[name].btnLoading = false
                                    if(!r.statusCode){
                                        that.$func.msg(r.message,'error');
                                    }else{
                                        that.$func.msg(r.message);
                                        that.$refs[name].resetFields();
                                        that.$emit('close');
                                    }
                                })
                            }

                        }
                    }

                })
            }
        }
    };
</script>